<section class="title">
  <!--  <i class="fa-light fa-circle-exclamation"></i>-->
  <h2 class="heading-5">
    {{ data.titleText || 'Are you sure you want to do this?' }}
  </h2>
</section>

<p class="body mt-12">
  {{ data.descriptionText || 'Double check you want to confirm this action' }}
</p>

<section class="actions mt-16">
  <app-button
    dataLabel="confirm-no"
    [buttonOptions]="{
      variant: 'secondary',
    }"
    (onClick)="dialogRef.close(false)"
  >
    {{ data.cancelText || 'No' }}
  </app-button>

  <app-button dataLabel="confirm-yes" (onClick)="dialogRef.close(true)">
    {{ data.confirmText || 'Yes' }}
  </app-button>
</section>

<button (click)="dialogRef.close(false)" class="close-button">
  <i class="fa-regular fa-xmark"></i>
</button>
